import childProcess from "child_process";
import consoleLogFormatted from "consoleLogFormatted";
export const executeCommandLine = ({ command, messageOnError, shouldThrowError = false, logLevel = "warning", }) => {
    try {
        return childProcess.execSync(command).toString().trim();
    }
    catch (err) {
        if (shouldThrowError) {
            throw err;
        }
        else {
            consoleLogFormatted[logLevel](messageOnError);
        }
    }
};
//# sourceMappingURL=commandLineHelpers.js.map